// https://zenoo.github.io/mui-theme-creator/
export const muiTheme = {
  cssVariables: true,
  palette: {
    mode: 'light',
    primary: {
      main: '#1e6dad',
    },
    secondary: {
      main: '#439edd',
    },
    dark: {
      main: '#272b30',
      light: '#272b30',
      dark: '#272b30',
      contrastText: '#fff',
    },
  },
  components: {
    MuiFormGroup: {
      styleOverrides: {
        root: {
          '&.MuiRadioGroup-root': {
            marginInlineStart: '1rem',
          },
          '&.Mui-error .MuiFormControlLabel-root': {
            color: 'var(--mui-palette-error-main)',
          }
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          '&.Mui-expanded': {
            margin: 0,
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          '.MuiAccordionSummary-content': {
            alignItems: 'center',
            gap: '1rem',
            margin: '0.75rem 0',
          },
          '.MuiAccordionSummary-content.Mui-expanded': {
            margin: '0.75rem 0',
          },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        input: {
          '&:autofill, &:-webkit-autofill': {
            color: 'inherit',
            WebkitTextFillColor: 'inherit !important',
            WebkitBoxShadow: 'inherit !important',
            caretColor: 'inherit !important',
          },
        },
      },
    },
  },
};
export const muiThemeDark = {
  cssVariables: true,
  palette: {
    mode: 'dark',
    primary: {
      main: '#1e6dad',
    },
    secondary: {
      main: '#439edd',
    },
    dark: {
      main: '#272b30',
      light: '#272b30',
      dark: '#272b30',
      contrastText: '#fff',
    }
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& label.Mui-focused': {
            color: 'var(--mui-palette-text-secondary)',
          },
          '& label.Mui-error': {
            // color: 'inherit',
            color: 'var(--mui-palette-error-dark)',
          },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          '&.Mui-error': {
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
            color: 'var(--mui-palette-error-dark)',
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          '&.Mui-error': {
            backgroundColor: 'var(--mui-palette-error-dark)',
            color: 'var(--mui-palette-error-contrastText)',
            margin: 0,
            padding: '0.15rem 1rem',
          },
        },
      },
    },
  },
};
